import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const gcContentTool: Tool = {
  id: "gc-content",
  name: () => m.gc_tool_name(),
  description: () => m.gc_tool_description(),
  icon: "🧬",
  basePath: "/gc-content",
  status: "stable",
  tags: ["bioinformatics", "dna", "rna", "sequence", "science", "gc-content"],
};
